export const sortById = (a: { id?: number }, b: { id?: number }) => a.id - b.id;
